import { createAsyncActions, TLoginState } from 'store';

enum ELoginActions {
  LOGIN = 'login/LOGIN'
}

export const loginSet = createAsyncActions<TLoginState>(ELoginActions.LOGIN);
